/* tslint:disable */
/* eslint-disable */
/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ArtistLocationDto } from '../models';
/**
 * ArtistLocationsApi - axios parameter creator
 */
export const ArtistLocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} artistLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistLocationsArtistLocationIdDelete: async (artistLocationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artistLocationId' is not null or undefined
            assertParamExists('apiArtistLocationsArtistLocationIdDelete', 'artistLocationId', artistLocationId)
            const localVarPath = `/api/ArtistLocations/{artistLocationId}`
                .replace(`{${"artistLocationId"}}`, encodeURIComponent(String(artistLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} artistLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistLocationsArtistLocationIdGet: async (artistLocationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artistLocationId' is not null or undefined
            assertParamExists('apiArtistLocationsArtistLocationIdGet', 'artistLocationId', artistLocationId)
            const localVarPath = `/api/ArtistLocations/{artistLocationId}`
                .replace(`{${"artistLocationId"}}`, encodeURIComponent(String(artistLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [artistId] 
         * @param {string} [city] 
         * @param {string} [state] 
         * @param {string} [postalCode] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {number} [milesRadius] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistLocationsGet: async (artistId?: string, city?: string, state?: string, postalCode?: string, latitude?: number, longitude?: number, milesRadius?: number, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ArtistLocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (artistId !== undefined) {
                localVarQueryParameter['ArtistId'] = artistId;
            }

            if (city !== undefined) {
                localVarQueryParameter['City'] = city;
            }

            if (state !== undefined) {
                localVarQueryParameter['State'] = state;
            }

            if (postalCode !== undefined) {
                localVarQueryParameter['PostalCode'] = postalCode;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['Latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['Longitude'] = longitude;
            }

            if (milesRadius !== undefined) {
                localVarQueryParameter['MilesRadius'] = milesRadius;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['StartDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['EndDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ArtistLocationDto} [artistLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistLocationsPost: async (artistLocationDto?: ArtistLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ArtistLocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(artistLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ArtistLocationDto} [artistLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistLocationsPut: async (artistLocationDto?: ArtistLocationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ArtistLocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(artistLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtistLocationsApi - functional programming interface
 */
export const ArtistLocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtistLocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} artistLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistLocationsArtistLocationIdDelete(artistLocationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistLocationsArtistLocationIdDelete(artistLocationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistLocationsApi.apiArtistLocationsArtistLocationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} artistLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistLocationsArtistLocationIdGet(artistLocationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistLocationsArtistLocationIdGet(artistLocationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistLocationsApi.apiArtistLocationsArtistLocationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [artistId] 
         * @param {string} [city] 
         * @param {string} [state] 
         * @param {string} [postalCode] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {number} [milesRadius] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistLocationsGet(artistId?: string, city?: string, state?: string, postalCode?: string, latitude?: number, longitude?: number, milesRadius?: number, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistLocationsGet(artistId, city, state, postalCode, latitude, longitude, milesRadius, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistLocationsApi.apiArtistLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ArtistLocationDto} [artistLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistLocationsPost(artistLocationDto?: ArtistLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistLocationsPost(artistLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistLocationsApi.apiArtistLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ArtistLocationDto} [artistLocationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistLocationsPut(artistLocationDto?: ArtistLocationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistLocationsPut(artistLocationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistLocationsApi.apiArtistLocationsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtistLocationsApi - factory interface
 */
export const ArtistLocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtistLocationsApiFp(configuration)
    return {
        /**
         * 
         * @param {ArtistLocationsApiApiArtistLocationsArtistLocationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistLocationsArtistLocationIdDelete(requestParameters: ArtistLocationsApiApiArtistLocationsArtistLocationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistLocationsArtistLocationIdDelete(requestParameters.artistLocationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArtistLocationsApiApiArtistLocationsArtistLocationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistLocationsArtistLocationIdGet(requestParameters: ArtistLocationsApiApiArtistLocationsArtistLocationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistLocationsArtistLocationIdGet(requestParameters.artistLocationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArtistLocationsApiApiArtistLocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistLocationsGet(requestParameters: ArtistLocationsApiApiArtistLocationsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistLocationsGet(requestParameters.artistId, requestParameters.city, requestParameters.state, requestParameters.postalCode, requestParameters.latitude, requestParameters.longitude, requestParameters.milesRadius, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArtistLocationsApiApiArtistLocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistLocationsPost(requestParameters: ArtistLocationsApiApiArtistLocationsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistLocationsPost(requestParameters.artistLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArtistLocationsApiApiArtistLocationsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistLocationsPut(requestParameters: ArtistLocationsApiApiArtistLocationsPutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistLocationsPut(requestParameters.artistLocationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiArtistLocationsArtistLocationIdDelete operation in ArtistLocationsApi.
 */
export interface ArtistLocationsApiApiArtistLocationsArtistLocationIdDeleteRequest {
    readonly artistLocationId: string
}

/**
 * Request parameters for apiArtistLocationsArtistLocationIdGet operation in ArtistLocationsApi.
 */
export interface ArtistLocationsApiApiArtistLocationsArtistLocationIdGetRequest {
    readonly artistLocationId: string
}

/**
 * Request parameters for apiArtistLocationsGet operation in ArtistLocationsApi.
 */
export interface ArtistLocationsApiApiArtistLocationsGetRequest {
    readonly artistId?: string

    readonly city?: string

    readonly state?: string

    readonly postalCode?: string

    readonly latitude?: number

    readonly longitude?: number

    readonly milesRadius?: number

    readonly startDate?: string

    readonly endDate?: string
}

/**
 * Request parameters for apiArtistLocationsPost operation in ArtistLocationsApi.
 */
export interface ArtistLocationsApiApiArtistLocationsPostRequest {
    readonly artistLocationDto?: ArtistLocationDto
}

/**
 * Request parameters for apiArtistLocationsPut operation in ArtistLocationsApi.
 */
export interface ArtistLocationsApiApiArtistLocationsPutRequest {
    readonly artistLocationDto?: ArtistLocationDto
}

/**
 * ArtistLocationsApi - object-oriented interface
 */
export class ArtistLocationsApi extends BaseAPI {
    /**
     * 
     * @param {ArtistLocationsApiApiArtistLocationsArtistLocationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistLocationsArtistLocationIdDelete(requestParameters: ArtistLocationsApiApiArtistLocationsArtistLocationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ArtistLocationsApiFp(this.configuration).apiArtistLocationsArtistLocationIdDelete(requestParameters.artistLocationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArtistLocationsApiApiArtistLocationsArtistLocationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistLocationsArtistLocationIdGet(requestParameters: ArtistLocationsApiApiArtistLocationsArtistLocationIdGetRequest, options?: RawAxiosRequestConfig) {
        return ArtistLocationsApiFp(this.configuration).apiArtistLocationsArtistLocationIdGet(requestParameters.artistLocationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArtistLocationsApiApiArtistLocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistLocationsGet(requestParameters: ArtistLocationsApiApiArtistLocationsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ArtistLocationsApiFp(this.configuration).apiArtistLocationsGet(requestParameters.artistId, requestParameters.city, requestParameters.state, requestParameters.postalCode, requestParameters.latitude, requestParameters.longitude, requestParameters.milesRadius, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArtistLocationsApiApiArtistLocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistLocationsPost(requestParameters: ArtistLocationsApiApiArtistLocationsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ArtistLocationsApiFp(this.configuration).apiArtistLocationsPost(requestParameters.artistLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArtistLocationsApiApiArtistLocationsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistLocationsPut(requestParameters: ArtistLocationsApiApiArtistLocationsPutRequest = {}, options?: RawAxiosRequestConfig) {
        return ArtistLocationsApiFp(this.configuration).apiArtistLocationsPut(requestParameters.artistLocationDto, options).then((request) => request(this.axios, this.basePath));
    }
}

